<script>
export default {
  name: "TransportAccounting"
}
</script>


<template>
  <div class="tab-content bg-light">
    <div class="tab-pane active " id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
      <h1>Транспортный учет</h1>
      <div id="xapp"></div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted, shallowRef } from "vue";
import {createTransportAccounting, getTransportAccounting, updateTransportAccounting} from "@/API/ways/work";
import x_spreadsheet from "x-data-spreadsheet-wertolet/src/index.js";
import SaveRow from "@/core/dto/saveRow"
import {webSocketService} from "@/helpers/websocket";

// Создаем глобальную ссылку на экземпляр таблицы
const spreadsheet = shallowRef(null);

const props = defineProps({
  role: {
    type: String,
    default: "user",
  }
})

const userId = ref(localStorage.getItem("userId"));

const options = {
  // mode: 'read',
  showToolbar: true,
  showGrid: true,
  showBottomBar: true,
  style: {
    bgcolor: '#ffffff',        // цвет фона для всех ячеек
    align: 'left',           // выравнивание текста по центру
    valign: 'bottom',          // вертикальное выравнивание по центру
    textwrap: false,            // перенос текста в ячейке
    underline: false,          // подчеркнутый текст
    color: '#333',             // цвет текста
    font: {
      name: 'Arial',
      size: 11,
      bold: false,
      italic: false,
    }
  },
  view: {
    height: () => document.documentElement.clientHeight - 35,
    width: () => document.documentElement.clientWidth - 50
  },
  cols: { len: 27 }
};
const firstRowStyle = {
  bgcolor: '#b7dee8',
  textwrap: true,
  color: '#000000',
  border: {
    top: ['thin', '#000000'],
    bottom: ['thin', '#000000'],
    right: ['thin', '#000000'],
    left: ['thin', '#000000'],
  },
  font: {
    name: 'Arial',
    size: 11,
    bold: true,
    italic: false,
  }
};
const firstRow = {
  cells: {
    0: {text: 'Дата выгрузки', style: 0, editable: false},
    1: {text: '№ Контейнера, Номер ТТН или Номер заявки', style: 0, editable: false},
    2: {text: 'Груз', style: 0, editable: false},
    3: {text: 'Тип контейнера/тонаж', style: 0, editable: false},
    4: {text: 'Дата сдачи документов водителем', style: 0, editable: false},
    5: {text: 'Адрес доставки/ Назначение счета', style: 0, editable: false},
    6: {text: 'Наша Фирма', style: 0, editable: false},
    7: {text: 'Клиент', style: 0, editable: false},
    8: {text: 'форма опла-ты нам  С/БЕЗ НДС', style: 0, editable: false},
    9: {text: 'Сумма', style: 0, editable: false},
    10: {text: '№ счета', style: 0, editable: false},
    11: {text: 'Дата счета', style: 0, editable: false},
    12: {text: 'Дата оплаты нам', style: 0, editable: false},
    13: {text: 'Подрядчик', style: 0, editable: false},
    14: {text: 'Водитель АМ', style: 0, editable: false},
    15: {text: 'Форма оплаты подрядчику C / БЕЗ НДС', style: 0, editable: false},
    16: {text: 'Ставка подрядчику', style: 0, editable: false},
    17: {text: 'Сумма выданных/оплаченых средств', style: 0, editable: false},
    18: {text: '№ Счета и сумма за гсм, запчаст', style: 0, editable: false},
    19: {text: 'Дата оплаты подрядчику', style: 0, editable: false},
    20: {text: 'Ведущий Менеджер', style: 0, editable: false},
    21: {text: 'Ведущий по вызову/Начальник отдела', style: 0, editable: false},
    22: {text: 'Ведущий по клиенту (Как правило начальник отдела)', style: 0, editable: false},
    23: {text: 'Менеджер по продажам', style: 0, editable: false},
    24: {text: 'Доп расходы', style: 0, editable: false},
    25: {text: 'Доход', style: 0, editable: false},
    26: {text: 'Доход полученый', style: 0, editable: false}
  },
  height: 100
};

let rows = {0: firstRow};

let tableInfo = ref({})

const MAX_COLUMN_INDEX = 25; // Максимальный индекс колонки (0-25, всего 26 колонок)

// Функция для санитизации данных перед отправкой на бэкенд
function sanitizeRowData(rowData) {
  // Создаем новый объект только с нужными данными
  const sanitized = {};
  // Улучшенная обработка ID
  if (rowData.id !== undefined && rowData.id !== null) {
    // Если ID передан как строка, преобразуем его в число
    const parsedId = typeof rowData.id === 'string' ? parseInt(rowData.id, 10) : rowData.id;
    if (!isNaN(parsedId)) {
      sanitized.id = parsedId;
    }
  }
  // Устанавливаем null только если ID явно не определен
  // Это позволит создавать новые записи
  if (!('id' in sanitized)) {
    sanitized.id = null;
  }
  // if (rowData.id !== undefined &&
  //     typeof rowData.id === 'number') {
  //   sanitized.id = rowData.id;
  // }
  // else {
  //   sanitized.id = null;
  // }

  // Обновим максимальный индекс колонки до 26
  const MAX_ALLOWED_COLUMN = 26;

  // Копируем только поля из первых 27 колонок (с индексами 0-26)
  for (let i = 0; i <= MAX_ALLOWED_COLUMN; i++) {
    const columnName = SaveRow.columns[i];
    if (columnName && columnName !== 'id' && rowData[columnName] !== undefined) {
      sanitized[columnName] = rowData[columnName];
    }
  }

  // Явно удаляем все поля, которые могли быть за пределами разрешенных колонок
  for (const key in rowData) {
    if (!sanitized.hasOwnProperty(key) && key !== 'id') {
      // Не копируем это поле в sanitized
    }
  }

  return sanitized;
}

const replaceRowData = async (data, ci, ri) => {
    console.log('replaceRowData >>> ', data);
    const updatedRow = data.object?.[0];
        if (updatedRow) {
          // if (!existingRowId) {
          //   rows[ri].cells[28] = { text: updatedRow.id };
          // }

          Object.keys(SaveRow.columns).forEach(colIndex => {
            const columnName = SaveRow.columns[colIndex];
            s.sheet.data.rows._[ri].cells[colIndex] = {
              text: updatedRow[columnName] ?? '',
              ...s.sheet.data.rows._[ri].cells[colIndex]
            };
          });
        }
  }

const connectToWebSocket = () => {
  if (userId.value) {
    webSocketService.connect("transportAccounting", Number(userId.value));
  } else {
    console.error('UserId не установлены');
  }
};

onMounted(async () => {
  setTimeout(() => {
    document.body.style.overflow = 'hidden';
  }, 500);
  await getTransportAccounting(props.role).then((response) => {
    tableInfo.value = response.data.object;
    console.log('tableInfo.value >>> ', tableInfo.value);

    const sheets = [];  // Массив для хранения листов

    const entries = Object.entries(tableInfo.value);
    console.log('entries >>> ', entries);
    for (let i = 0; i < entries.length; i++) {
      const monthKey = entries[i][0];
      const monthData = entries[i][1];
      console.log(monthKey, monthData);

      const rows = { 0: firstRow };  // Создаём rows для каждого месяца
      rows.len = monthData.length + 500;

      for (let j = 0; j < monthData.length; j++) {
        rows[j + 1] = {
          cells: {
            0: {text: monthData[j].dateOfPickup},
            1: {text: monthData[j].numberOfContainer},
            2: {text: monthData[j].cargo},
            3: {text: monthData[j].typeOfContainer},
            4: {text: monthData[j].dateOfSubmission},
            5: {text: monthData[j].addressOfDelivery},
            6: {text: monthData[j].ourFirm},
            7: {text: monthData[j].client},
            8: {text: monthData[j].formPayAs},
            9: {text: monthData[j].summa},
            10: {text: monthData[j].numberOfBill},
            11: {text: monthData[j].dateOfBill},
            12: {text: monthData[j].datePayment},
            13: {text: monthData[j].contractor},
            14: {text: monthData[j].driver},
            15: {text: monthData[j].formPayHim},
            16: {text: monthData[j].contractorRate},
            17: {text: monthData[j].sumIssued},
            18: {text: monthData[j].numberOfBillAdd},
            19: {text: monthData[j].dateOfPaymentContractor},
            20: {text: monthData[j].manager},
            21: {text: monthData[j].clientLead},
            22: {text: monthData[j].departmentHead},
            23: {text: monthData[j].salesManager},
            24: {text: monthData[j].additionalExpenses},
            25: {text: monthData[j].income, editable: false},
            26: {text: monthData[j].incomeLearned, editable: false},
            28: {text: monthData[j].id},
          }
        };
      }

    // Добавляем лист для текущего месяца
    sheets.push({
          name: monthKey,
          freeze: 'A1',
          styles: [firstRowStyle],
          cols: { len: 27 },
          rows
        });
    }
  connectToWebSocket();

  const s = new x_spreadsheet('#xapp', options)
      .loadData(sheets);

  // Сохраняем ссылку на экземпляр
  spreadsheet.value = s;

  const data = s.getData();

  // Универсальный обработчик изменений ячеек
const processChanges = async (changes) => {
  console.log("changes packetage >>> ", changes);
  // Если передано одиночное изменение (не массив)
  if (!Array.isArray(changes)) {
    if (changes.ci > 24) return;
    // Используем существующую логику для одиночных ячеек
    return updateRowData(changes.value, changes.ri, changes.ci);
  }

  // Если изменений нет или пустой массив
  if (!changes.length) {
    console.log('нет изменений')
    return
  };


  // Группируем изменения по строкам
  const changesByRow = {};

  // Сортируем изменения по строкам
  changes.forEach(change => {
    const { ri, ci, value } = change;

    // Пропускаем заголовок (первую строку)
    if (ri < 1) return;

    // Пропускаем недопустимые столбцы
    if (ci > 26) return;

    // Инициализируем структуру для строки, если еще не существует
    if (!changesByRow[ri]) {
      changesByRow[ri] = {
        rowId: s.sheet.data.rows._[ri]?.cells[28]?.text,
        changes: {}
      };
    }

    // Добавляем изменение в соответствующую строку
    changesByRow[ri].changes[ci] = value;
  });

  // Обрабатываем каждую строку отдельно
  for (const [ri, rowData] of Object.entries(changesByRow)) {
    const { rowId, changes } = rowData;

    // Создаем объект для сохранения
    const saveRow = new SaveRow();
    if (rowId) {
      saveRow.id = rowId;
    }

    // Заполняем данные из изменений, сохраняя оригинальную логику преобразования типов
    for (const [ci, value] of Object.entries(changes)) {
      const columnIndex = parseInt(ci);

      // Сохраняем оригинальную логику обработки разных типов столбцов
      if (columnIndex === 0 || columnIndex === 4 || columnIndex === 11 || columnIndex === 12 || columnIndex === 19) {
        // Обработка дат
        let date = value.trim().split(" ")[0];
        if (date.split(".").length > 1) {
          let dateArr = date.split(".");
          saveRow[SaveRow.columns[columnIndex]] = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1,
              parseInt(dateArr[0]) + 1);
        } else {
          let dateArr = date.split("-");
          saveRow[SaveRow.columns[columnIndex]] = new Date(parseInt(dateArr[0]), parseInt(dateArr[1]) - 1,
              parseInt(dateArr[2]) + 1);
        }
      } else if (columnIndex === 9 || columnIndex === 16 || columnIndex === 17 || columnIndex === 24) {
        // ТУПО проверяем на пустоту
        if (!value || value === '' || value === undefined) {
            saveRow[SaveRow.columns[columnIndex]] = null;
        } else {
            try {
                // ТУПО пытаемся преобразовать в число
                const parsedValue = parseFloat(String(value).replace(/[^\d.,]/g, '').replace(',', '.'));
                saveRow[SaveRow.columns[columnIndex]] = isNaN(parsedValue) ? null : parsedValue;
            } catch (error) {
                // Если что-то пошло не так - просто null
                saveRow[SaveRow.columns[columnIndex]] = null;
            }
        }
      } else if (columnIndex === 7) {
        // Проверяем, есть ли value и содержит ли "ИНН"
        if (value && typeof value === 'string' && value.includes("ИНН ")) {
          saveRow[SaveRow.columns[columnIndex]] =value.split("ИНН ")[1];
        } else {
          // Если value пустое или не строка, устанавливаем пустой объект с пустым inn
          saveRow[SaveRow.columns[columnIndex]] = value && typeof value === 'string'
            ? value.trim().replace(" ", "")
            : "";
        }
      } else {
        // Стандартная обработка текста
        saveRow[SaveRow.columns[columnIndex]] = value;
      }
    }

    try {
      console.log('saveRow >>>', saveRow);
      // Перед отправкой данных на бэкенд
      const cleanRowData = sanitizeRowData(saveRow);
      console.log('cleanRowData >>>', cleanRowData);
      // Отправляем запрос
      const saveResponse = rowId
        ? await updateTransportAccounting([cleanRowData])
        : await createTransportAccounting([cleanRowData]);

      console.log(`Строка ${ri} успешно обновлена:`, saveResponse.data);

    } catch (error) {
      console.error(`Ошибка при обновлении строки ${ri}:`, error);

      // При ошибке восстанавливаем значения из базы
      if (rowId) {
        try {
          const queryRow = new SaveRow();
          queryRow.id = rowId;
          const response = await updateTransportAccounting([queryRow]);

          if (response?.data?.object) {
            const actualRow = response.data.object.find(row => row.id === rowId);
            if (actualRow) {
              // Восстанавливаем значения из базы
              for (const ci of Object.keys(changes)) {
                s.sheet.data.rows._[ri].cells[ci].text = actualRow[SaveRow.columns[ci]] ?? '';
              }
            }
          }
        } catch (fetchError) {
          console.error('Ошибка при получении актуальных данных:', fetchError);
        }
      }
    }
  }

  // Перерисовываем таблицу
  s.reRender();
};

  const updateRowData = async (cell, ri, ci) => {
    console.log('updateRowData separate cell >>> ', cell, ri, ci);
    console.log('s.sheet.data >>> ', s.sheet.data);
    let saveRow = new SaveRow();
    // Получаем данные текущего активного листа

    const existingRowId = s.sheet.data.rows._[ri]?.cells[28]?.text;
    console.log('existingRowId >>> ', existingRowId);

    try {
      if (existingRowId) {
        saveRow.id = existingRowId;
      }
      if (ci === 9) {
        console.log('data >>> ', s.sheet.data);
        const formula = s.sheet.data.getCellTextOrDefault(ri, ci);
        saveRow[SaveRow.columns[ci]] = formula.startsWith('=') ? formula : cell;
        console.log('formula >>> ', formula);
        console.log('cell >>> ', cell);
        // Get the formula text instead of the calculated value
      } else {
        saveRow[SaveRow.columns[ci]] = cell;
      }
      console.log('saveRow for singe cell >>> ', saveRow);
      // Перед отправкой данных на бэкенд
      const cleanRowData = sanitizeRowData(saveRow);
      console.log('cleanRowData for singe cell >>>', cleanRowData);
      // Отправляем запрос
      const saveResponse = existingRowId
        ? await updateTransportAccounting([cleanRowData])
        : await createTransportAccounting([cleanRowData]);

      console.log('Response format:', saveResponse.data);

      if (saveResponse?.data?.operationResult === 'OK') {
        console.log('через сокет')
      }
    } catch (error) {
      // В случае ошибки восстанавливаем данные из ответа
      console.error('Ошибка при сохранении/обновлении данных:', error);

      // При ошибке получаем актуальные данные из базы
        try {
          const queryRow = new SaveRow();
          queryRow.id = existingRowId;
          const response = await updateTransportAccounting([queryRow]);
          if (response?.data?.object) {
            const actualRow = response.data.object.find(row => row.id === existingRowId);
            if (actualRow) {
              // Восстанавливаем предыдущее значение из базы
              s.sheet.data.rows._[ri].cells[ci].text = actualRow[SaveRow.columns[ci]] ?? '';
            }
          }
        } catch (fetchError) {
          console.error('Ошибка при получении актуальных данных:', fetchError);
        }

    } finally {
      s.reRender();
    }
  }

  s.on('cell-selected', (cell, ri, ci) => {
    s.reRender();
    // setTimeout(() => {
    //   // xs.loadData([{ rows }]);
    //   s.cellText(14, 3, 'cell-text').reRender();
    //   console.log('cell(8, 8):', s.cell(8, 8));
    //   console.log('cellStyle(8, 8):', s.cellStyle(8, 8));
    // }, 5000);
    // console.log('cell-selected >>>> ', rows[ri].cells[28].text);
  });
  // s.change(data => {
  //   console.log("change >>>> ", data);
  // });
  s.on('cells-delete', (cell) => {
  console.log('delete-cell>>>', cell);

  // Собираем изменения для удаления
  const changes = [];
  for (let ri = cell.sri; ri <= cell.eri; ri++) {
    // Пропускаем заголовок таблицы
    if (ri >= 1) {
      for (let ci = cell.sci; ci <= cell.eci; ci++) {
        if (ci <= 24) { // Проверяем, что столбец в допустимом диапазоне
          changes.push({
            ri: ri,
            ci: ci,
            value: '' // При удалении устанавливаем пустое значение
          });
        }
      }
    }
  }

  // Используем новый метод processChanges для оптимизации запросов
  processChanges(changes);
});

  s.on('cell-edited', async(cell, ri, ci) => {
  });

  s.on('cell-finished-edit', async(cell, ri, ci) => {
    console.log('cell-finished-edit');
    console.log('cell >>> ', cell);
    console.log('ri >>> ', ri);
    console.log('ci >>> ', ci);
    updateRowData(cell, ri, ci);


    // let saveRow = new SaveRow();
    // const existingRowId = rows[ri].cells[28]?.text;

    // try {
    //   if (existingRowId) {
    //     saveRow.id = existingRowId;
    //   }
    //   saveRow[SaveRow.columns[ci]] = cell;

    //   const saveResponse = existingRowId
    //     ? await updateTransportAccounting([saveRow])
    //     : await createTransportAccounting([saveRow]);

    //   console.log('Response format:', saveResponse.data);

    //   if (saveResponse?.data?.operationResult === 'OK') {
    //     const updatedRow = saveResponse.data.object?.[0];
    //     if (updatedRow) {
    //       if (!existingRowId) {
    //         rows[ri].cells[28] = { text: updatedRow.id };
    //       }

    //       Object.keys(SaveRow.columns).forEach(colIndex => {
    //         const columnName = SaveRow.columns[colIndex];
    //         rows[ri].cells[colIndex] = {
    //           text: updatedRow[columnName] ?? '',
    //           ...rows[ri].cells[colIndex]
    //         };
    //       });
    //     }
    //   }
    // } catch (error) {
    //   // В случае ошибки восстанавливаем данные из ответа
    //   console.error('Ошибка при сохранении/обновлении данных:', error);

    //   // При ошибке получаем актуальные данные из базы
    //     try {
    //       const response = await getTransportAccounting(props.role);
    //       if (response?.data?.object) {
    //         const actualRow = response.data.object.find(row => row.id === existingRowId);
    //         if (actualRow) {
    //           // Восстанавливаем предыдущее значение из базы
    //           rows[ri].cells[ci].text = actualRow[SaveRow.columns[ci]] ?? '';
    //         }
    //       }
    //     } catch (fetchError) {
    //       console.error('Ошибка при получении актуальных данных:', fetchError);
    //     }

    // } finally {
    //   s.reRender();
    // }
  });

 s.on('pasted-clipboard', async(data) => {
    console.log('>>>> pasted-clipboard ', data);
    if (data.startColumn > 24) {
      return
    }
    if (data.endColumn > 24) {
      data.endColumn = 24
    }

    // Собираем массив изменений для processChanges
    const changes = [];
    for (let i = data.startRow; i <= data.endRow; i++) {
      for (let j = data.startColumn; j <= data.endColumn; j++) {
        // Безопасное получение значения
        const cellValue = s.sheet.data.rows._[i]?.cells?.[j]?.text ?? '';
        changes.push({
            ri: i,
            ci: j,
            value: cellValue // Всегда будет как минимум пустая строка
        });
      }
    }

    // Используем новый метод вместо старой логики
    await processChanges(changes);
  });

  s.on('cells-pulling', (cells) => {
    console.log('cells-pulling >>> ', cells);
    if (cells.sci > 24 || cells.sri < 1) {
      return;
    }
    if (cells.eci > 24) {
      cells.eci = 24
    }

    // Собираем массив изменений
    const changes = [];
    for (let i = cells.sri; i <= cells.eri; i++) {
      for (let j = cells.sci; j <= cells.eci; j++) {
        changes.push({
          ri: i,
          ci: j,
          value: s.sheet.data.rows._[i].cells[j].text
        });
      }
    }

    // Используем новый метод processChanges для оптимизации запросов
    processChanges(changes);
  });

  s.on('redo', async(data) => {
    let saveRows = [];
    let counter = -1;
    for (let key in data.rows._) {
      let rowId = parseInt(key, 10);
      if (s.sheet.data.rows._[rowId].cells[28]) {
        let saveRowDto = new SaveRow();
        saveRowDto.id = s.sheet.data.rows._[rowId].cells[28].text;
        for (let j = 0; j < 25; j++) {
          s.sheet.data.rows._[rowId].cells[j].text = data.rows._[rowId].cells[j].text;
          saveRowDto[SaveRow.columns[j]] = s.sheet.data.rows._[rowId].cells[j].text;
        }
        saveRows[++counter] = saveRowDto;
      }
    }
    if (saveRows.length > 0) {
      console.log('>>>> redo ', saveRows);
      const cleanRows = saveRows.map(row => sanitizeRowData(row));
      await updateTransportAccounting(cleanRows);
    }
  });
  s.on('undo', async(data) => {
    console.log('data >>> ', data);
    const formula = data.getCellTextOrDefault(1, 9);
    console.log('formula >>> ', formula);

    console.log(data);
    let dataRowsSave = JSON.parse(JSON.stringify(data));
    console.log(data);
    let saveRows = [];
    let counter = -1;
    for (let key in dataRowsSave._) {
      let rowId = parseInt(key, 10);
      if (s.sheet.data.rows._[rowId].cells[28]) {
        let saveRowDto = new SaveRow();
        saveRowDto.id = s.sheet.data.rows._[rowId].cells[28].text;
        for (let j = 0; j < 25; j++) {
          if (j === 7) {
            s.sheet.data.rows._[rowId].cells[j].text = dataRowsSave._[rowId].cells[j].text;
            saveRowDto[SaveRow.columns[j]].inn = s.sheet.data.rows._[rowId].cells[j].text.split("ИНН ")[1];
          } else {
            s.sheet.data.rows._[rowId].cells[j].text = dataRowsSave._[rowId].cells[j].text;
            saveRowDto[SaveRow.columns[j]] = s.sheet.data.rows._[rowId].cells[j].text;
          }
        }
        saveRows[++counter] = saveRowDto;
      }
    }
    if (saveRows.length > 0) {
      console.log('>>>>>> undo ', saveRows);
      const cleanRows = saveRows.map(row => sanitizeRowData(row));
      await updateTransportAccounting(cleanRows);
    }
  });
})

});

onUnmounted(() => {
  webSocketService.disconnect();
});

// Обработчик WebSocket сообщений
webSocketService.on('messageReceived', (message) => {
  console.log('Сообщение прослушано в транспортаккаунтинге', message);
  if (message?.transportAccountingDTO?.[0]) {
    const updatedRow = message.transportAccountingDTO[0];

    // Получаем ссылку на таблицу
    const s = spreadsheet.value;
    if (!s) return;

    // Находим строку по ID
    let rowIndex = null;
    Object.keys(s.sheet.data.rows._).forEach(ri => {
      if (+s.sheet.data.rows._[ri]?.cells?.[28]?.text === +updatedRow.id) {
        rowIndex = parseInt(ri, 10);
      }
    });

    if (rowIndex === null) return;

    // Обновляем ячейки строки напрямую в структуре данных
    Object.keys(SaveRow.columns).forEach(colIndex => {
      const columnName = SaveRow.columns[colIndex];
      if (updatedRow[columnName] !== undefined) {
        // Получаем текущие стили ячейки
        const currentCell = s.sheet.data.rows._[rowIndex].cells[parseInt(colIndex)] || {};
        const newValue = updatedRow[columnName];

        // Напрямую обновляем ячейку в структуре данных
        s.sheet.data.rows._[rowIndex].cells[parseInt(colIndex)] = {
          ...currentCell,
          text: newValue !== null ? String(newValue) : ''
        };
      }
    });

    // // Форсируем полное обновление
    // s.sheet.resetData(s.sheet.data);
    s.sheet.reload();
    s.reRender();

    // // Дополнительно через setTimeout для гарантии
    // setTimeout(() => {
    //   s.reRender();
    // }, 100);
  }
});

</script>


<style scoped>
</style>